<template>
    <div class="content">
        <p
            v-if="slotData.textContent !== null && slotData.textContent !== undefined"
            class="content-text-info"
        >
            {{ slotData.textContent }}
        </p>
        <p>{{ addressinfo }}</p>
        <br>
        <dynamic-table
            :table-data="slotData.tableData"
            :show-footer="false"
            :show-footer-legend="false"
            :show-dot-column="false"
            @row-clicked="tableRowClicked"
        />
        <br>
        <!-- eslint-disable vue/no-v-html -->
        <span v-html="infotext" />
        <!--eslint-enable-->
    </div>
</template>

<script lang="ts">
    import { Component, Vue, Watch } from "vue-facing-decorator"
    import DynamicTableResponsive from "@/components/DynamicTableResponsive.vue"
    import DynamicRightSlotData from "@/models/dynamicrighslotdata"
    import ApiService from "@/services/ApiService"
    import SearchResultModel from "@/models/searchresultmodel"
    import { store } from '@/store/store'

    @Component({
        components: {
            "dynamic-table": DynamicTableResponsive
        }
    })
    export default class AntenniTVSaatavuus extends Vue {
        apiService: ApiService = new ApiService(store.getters.baseHref)

        // DataPublishServices rajapintakutsun etuosa
        apiCallBasePart: string = "v1/TVJaRadio/"

        // Onko konponentti aktiivinen. keep-alive jättää komponentin käyntiin ja
        // searchAddressSelected event laukeaa myös deaktivoidussa komponentissa.
        active = false

        activated() {
            this.active = true
        }

        deactivated() {
            this.active = false
        }

        get searchAddressSelected(): SearchResultModel | null {
            return store.getters.searchAddressSelected
        }

        get addressinfo(): string | undefined {
            if (this.searchAddressSelected !== null) {
                return this.$t("App.RadioJaTV.AntenniTV.RightSlot.InfoText") + " " + this.searchAddressSelected.getFullName() + "."
            }
        }

        @Watch("searchAddressSelected")
        onSearchAddressSelected(): void {
            if (this.active && store.getters.searchAddressSelected == null) {
                store.dispatch("setRightSlotData", [])
            }
        }

        async tableRowClicked(row: number) {
            if (this.slotData?.tableData?.data === null) {
                return
            }

            const tvSaatavuus: any = this.slotData?.tableData?.data ?? []
            const header = (this.$t("App.TVSaatavuus.Lahetin") ?? "") + tvSaatavuus[row].nimi
            store.dispatch("setHeader", header)
            // kerätään ID arraysta
            const filters = new URLSearchParams()
            tvSaatavuus[row].idlist.forEach(function (value) {
                filters.append("lahetinId", value.toString())
            })
            store.dispatch("setDataUrlToLoad", { url: this.apiCallBasePart + "TVKanavat", type: "TVKanavatModal", params: filters })
        }

        get slotData(): DynamicRightSlotData | null {
            return store.getters.rightSlotData as DynamicRightSlotData
        }

        get infotext(): string | undefined {
            return this.$t("App.TVSaatavuus.InfoText")
        }
    }
</script>
